import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions';
import Index from './Index.vue';

// Trang dap sau dang nhap — ai vao duoc hoi thoai thi vao duoc day.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/pages'),
    name: 'bonboz_main_page',
    meta: { permissions: [...ROLES, ...CONVERSATION_PERMISSIONS] },
    component: Index,
  },
];
